<template>
  <div v-loading="loading" class="rj-page-card" style="padding-top: 0">
    <div class="rj-page-card__title">
      云桌面选配产品
    </div>
    <div class="rj-page-card__content">
      <!--      <div class="miaoshu">-->
      <!--        <div class="totalMoney">-->
      <!--          总计：{{ Number(totoal).toFixed(2) }}-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="el-table el-table--fit el-table--border el-table--enable-row-transition el-table--mini" style="width: 100%;">
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
            <colgroup>
              <col width="20%">
              <col width="40%">
              <col width="40%">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
            </colgroup>
            <thead class="has-gutter">
              <tr class="">
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    产品分类
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    商品名称
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    规格型号
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    成交价(元)
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    单价(元)
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    数量
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    套数
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    订单金额(元)
                  </div>
                </th>
                <th colspan="1" rowspan="1" class=" is-center is-leaf">
                  <div class="cell">
                    是否购买PSC
                  </div>
                </th>
                <th colspan="1" rowspan="1" class="is-center is-leaf">
                  <div class="cell">
                    服务授权分类
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
            <colgroup>
              <col width="20%">
              <col width="40%">
              <col width="40%">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
              <col width="120">
            </colgroup>
            <tbody>
              <template v-for="(product,index) in tableData">
                <!--组合包表格UI 数据循环逻辑待定-->
                <tr v-for="(packmain,clomain) in product.productCloudPackageList" :key="index+'-'+'-pack-' +clomain" class="el-table__row">
                  <td class="is-center ">
                    <div class="cell">
                      {{ product.productCategoryName }}
                    </div>
                  </td>
                  <td v-if="clomain==0" :rowspan="product.productCloudPackageList.length" style="padding: 0;position:relative;">
                    <table width="100%" height="100%" class="groupTable">
                      <tr v-for="(pack,clo) in product.productCloudPackageList" :key="index+'-'+'-' +0+'-'+clo">
                        <td v-if="clo==0" class="is-center" :rowspan="product.productCloudPackageList.length">
                          {{ product.invoiceName }}
                        </td>
                        <td class=" borderBottom is-center">
                          {{ pack.invoiceName }}
                        </td>
                      </tr>
                    </table>
                    <div class="groupTableline" />
                  </td>
                  <td v-if="clomain==0" :rowspan="product.productCloudPackageList.length" style="padding: 0;position:relative;">
                    <table width="100%" height="100%" class="groupTable">
                      <tr v-for="(pack,clo) in product.productCloudPackageList" :key="index+'-'+'-' +0+'-'+clo">
                        <td v-if="clo==0" class="is-center" :rowspan="product.productCloudPackageList.length">
                          {{ product.productName }}
                        </td>
                        <td class=" borderBottom is-center">
                          {{ pack.productName }}
                        </td>
                      </tr>
                    </table>
                    <div class="groupTableline" />
                  </td>
                  <td class="is-center ">
                    <div class="cell">
                      {{ Number(packmain.integratorsPrice).toFixed(2) }}
                    </div>
                  </td>
                  <td class="is-center ">
                    <div class="cell">
                      {{ Number(packmain.integratorsPrice).toFixed(2) }}
                    </div>
                  </td>
                  <td class="is-center ">
                    <div class="cell">
                      {{ packmain.productAmount }}
                    </div>
                  </td>
                  <td v-if="clomain==0" class="is-center " :rowspan="product.productCloudPackageList.length">
                    <div class="cell">
                      {{ product.productAmount }}
                    </div>
                  </td>
                  <td v-if="clomain==0" class="is-center " :rowspan="product.productCloudPackageList.length">
                    <div class="cell">
                      {{ Number( product.integratorsProductTotalPrice).toFixed(2) }}
                    </div>
                  </td>
                  <td v-if="clomain==0" class="is-center " :rowspan="product.productCloudPackageList.length">
                    <div class="cell">
                      {{ product.buyPsc=='true'?'是':'否' }}
                    </div>
                  </td>
                  <td v-if="clomain==0" class="is-center " :rowspan="product.productCloudPackageList.length">
                    <div class="cell">
                      {{ product.productPscType }}
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      loading: false,
      totoal: 0
    };
  },
  props: {
    // 数据由父组件传递
    tableData: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
  @import "../../../../style/var";
  .rj-tabs-body{
    padding: 0 10px;
  }
  .miaoshu{
    .totalMoney{
      color: $--color-danger;
      font-size: 15px;
    }
  }
.proTitle{
  font-size: 15px;
  .label{
    display: inline-block;
  }
  .money{
    color: $--color-danger;
    display: inline-block;
    margin-left: 25px;
  }
}
  .productTable{
    &.el-table::before{
      height: 0;
    }
    tr{
      td{
        border-right: 1px solid $--border-color-light;
        border-bottom: 1px solid $--border-color-light;
        &:last-child{
          border-right:none;
        }
      }
      &:last-child{
        td{
          border-bottom: none;
        }
      }
    }
  }
  .groupTable{
    table-layout: fixed;
    border-collapse: collapse;
    tr{
      td{
        padding: 10px 0;
        border: none;
        &.borderBottom{
          border-bottom: 1px solid $--border-color-light;
        }
      }
      &:last-child{
        td{
          &.borderBottom{
            border: none;
          }
        }
      }
    }
  }
  .groupTableline{
    position: absolute;
    width: 1px;
    height: 100%;
    background: $--border-color-light;
    top: 0;
    left: 50%;
  }
</style>
